const pageStore = {
  state: {
    orderActive: 0
  },
  mutations: {
    SET_ACTIVE: (state, orderActive) => {
      state.orderActive = orderActive
    }
  },
  actions: {
    orderActive({ commit }, orderActive) {
      commit('SET_ACTIVE', orderActive)
    }
  }
}

export default pageStore